<template>
    <div class="modal-dialog">
        <div class="modal-content" v-if="modalData.type === 'callback'">
            <!--            <div class="modal-header">-->
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <!--                <h4 class="modal-title">-->
            <!--                    {{ Lang.get('js.callback_form.title') }}-->
            <!--                </h4>-->
            <!--            </div>-->
            <div class="modal-body">
                <form-call-back></form-call-back>
            </div>
        </div>
        <div class="modal-content user-form" v-if="modalData.type === 'login'">
            <!--            <div class="modal-header">-->
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <!--            </div>-->
            <div class="modal-body">
                <auth-component></auth-component>
            </div>
        </div>
        <div class="modal-content" v-if="modalData.type === 'not-found'">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="modal-body premise-form">
                <form-not-found-Premises></form-not-found-Premises>
            </div>
        </div>
    </div>
</template>

<script>
    import FormCallBack from './forms/FormCallBack';
    import AuthComponent from './auth/AuthComponent';
    import FormContacts from "./forms/FormContacts";
    import FormNotFoundPremises from "./forms/FormNotFoundPremises";

    export default {
        name: "modal-master",
        components: {
            FormContacts,
            FormCallBack,
            AuthComponent,
            FormNotFoundPremises,
        },
        props: {
            modalData: {
                required: true,
                type: Object
            },
        },
        data() {
            return {
                Lang,
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/ModalMaster.vue